import { ReactEventHandler } from "react";

import {
  MDSCollectionIcon,
  MDSText,
  MDSTextColor,
  MDSTextOverflow,
  MDSTextVariant,
  MDSTextWeight,
  MDSIconKind,
  MDSButton,
  MDSButtonSlotName,
  MDSIcon,
  MDSActionMenuItem,
  MDSMenuItemHeaderVariant,
  MDSMenuItemHeader,
} from "@/mds";

import { useThemedCollectionColors } from "@/mds/themes/use-themed-collection-colors";

import {
  StyledCollectionPreviewContainer,
  StyledHeader,
  StyledHeaderTitle,
  StyledMain,
  StyledCardActions,
  StyledRecentNotesMenu,
} from "./collection-preview.style";

interface RecentNote {
  id: string;
  title: string;
}

interface CollectionPreviewViewProps {
  collectionId: string;
  collectionLabel: string;
  collectionDescription: string | undefined;
  recentNotes: RecentNote[];
  noteId: string | undefined;
  onRemove: React.MouseEventHandler;
  onOpenInSplit: ReactEventHandler;
  onOpenNote: (noteId: string) => void;
}

export const CollectionPreviewView = ({
  collectionId,
  collectionLabel,
  collectionDescription,
  recentNotes,
  noteId,
  onRemove,
  onOpenInSplit,
  onOpenNote,
}: CollectionPreviewViewProps) => {
  const { bgColor } = useThemedCollectionColors(collectionId);

  return (
    <StyledCollectionPreviewContainer>
      <StyledHeader $bgColor={bgColor}>
        <MDSCollectionIcon collectionId={collectionId} boxSize={32} size={16} />
        <StyledHeaderTitle>
          <MDSText variant={MDSTextVariant.TextS} weight={MDSTextWeight.SemiBold}>
            {collectionLabel}
          </MDSText>
          <MDSText
            variant={MDSTextVariant.TextXs}
            color={MDSTextColor.Secondary}
            overflow={MDSTextOverflow.Ellipsis}
          >
            {collectionDescription}
          </MDSText>
        </StyledHeaderTitle>
      </StyledHeader>
      <StyledMain>
        <StyledRecentNotesMenu>
          <MDSMenuItemHeader label="Recents" variant={MDSMenuItemHeaderVariant.Beginning} />
          {recentNotes.map(
            note =>
              note && (
                <MDSActionMenuItem
                  key={note.id}
                  id={note.id}
                  label={note.title}
                  icon={MDSIconKind.Document}
                  onClick={() => onOpenNote(note.id)}
                />
              )
          )}
        </StyledRecentNotesMenu>
        <StyledCardActions>
          {noteId && (
            <MDSButton onClick={onRemove}>
              <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={MDSIconKind.Exit} />
              Remove
            </MDSButton>
          )}
          <MDSButton onClick={onOpenInSplit}>
            <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={MDSIconKind.SplitPanel} />
            Open in split
          </MDSButton>
        </StyledCardActions>
      </StyledMain>
    </StyledCollectionPreviewContainer>
  );
};
